/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { DynamicGraphAdditionalInput } from '../objects/config';

export function getAdditionalInput(input: string | DynamicGraphAdditionalInput | undefined, key: keyof DynamicGraphAdditionalInput) {
    if (!input || typeof input === 'string') { return undefined; }
    return input[key];
}
